import { DialogActions } from "@material-ui/core";
import React from "react";
import DialogLayout from "../../../../partials/content/DialogLayout";
import SearchItemUom from "../../inventory/items/searchItemUom";

function SalesItemUom({
  openSearchUom,
  setOpenSearchUom,
  itemSelected,
  setFieldValue,
  property,
  itemIndex,
}) {
  return (
    <DialogLayout
      open={openSearchUom}
      title="Search Unit of Measurement"
      onCloseDialog={() => {
        setOpenSearchUom(false);
      }}
      maxWIdth="sm"
    >
      {itemSelected.itemID > 0 ? (
        <SearchItemUom
          itemID={itemSelected.itemID}
          onSelectUom={(uom) => {
            setFieldValue(`${property}[${itemIndex}].uomID`, uom.ID);
            setFieldValue(`${property}[${itemIndex}].uomName`, uom.uomName);
            setOpenSearchUom(false);
          }}
        />
      ) : null}
      <DialogActions>
        <button
          type="button"
          className="btn btn-label-danger btn-md btn-pill btn-bold"
          onClick={() => {
            setOpenSearchUom(false);
          }}
        >
          <i className="fas fa-window-close"></i>
          Close
        </button>
      </DialogActions>
    </DialogLayout>
  );
}

export default SalesItemUom;
